import { defineStore } from 'pinia'
import { GpvRepository, DojouMeshParams } from '@/repositories/gpv-repository'
import DojouMesh from '@/models/DojouMesh'

const storeKey = 'dojou_mesh'

export const useDojouMeshStore = defineStore(storeKey, {
  state: () => ({
    mesh: {} as DojouMesh,
  }),

  actions: {
    async fetch(params: DojouMeshParams) {
      const repository = new GpvRepository()
      const area = process.env.VUE_APP_TARGET === 'kawasaki' ? '1413' : '23203'
      const items = await repository.getDojouMesh({ ...params, area })

      this.mesh = { items }

      return this.mesh
    },
  },
})
